{% import Exception from './exception' %}

<div class="executable-fragment-wrapper{{ theme ? ' theme-' + theme + '-wrapper' : '' }}{{ shorterHeight ? ' executable-fragment-wrapper_gutter' : '' }}">
    <div class="executable-fragment {{ theme }}">
      {% if (!highlightOnly && !hideRun) %}
        <div class="run-button {{ waitingForOutput ? '_disabled' : ''}}" data-track-run-id="{{ dataTrackRunId || '' }}"
          :onclick={{ this.execute.bind(this) }}></div>
      {% endif %}
        <div class="code-area {{ folded ? '_folded' : '_unfolded' }}">
            {% if (isShouldBeFolded) %}
                <div class="fold-button {{ foldButtonHover ? '_hover' : '' }} {{ theme }}"
                    :onclick={{ this.onFoldButtonClick.bind(this) }}
                    :onmouseenter={{ this.onFoldButtonMouseEnter.bind(this) }}
                    :onmouseleave={{ this.onFoldButtonMouseLeave.bind(this) }}>
                </div>
            {% endif %}
            {% if (!folded && hasSchema) %}
                <div class="carousel-tabs {{ theme }}">
                    <button class="carousel-tab {{ activeTab === 'code' ? 'active' : '' }}" :onclick={{ this.onTabClick.bind(this, 'code') }}>Code</button>
                    <button class="carousel-tab {{ activeTab === 'schema' ? 'active' : '' }}" :onclick={{ this.onTabClick.bind(this, 'schema') }}>Schema</button>
                </div>
            {% endif %}
            <div class="carousel-content">
                <div class="carousel-item {{ activeTab === 'code' ? 'active' : '' }}">
                    <textarea></textarea>
                </div>
                {% if (!folded && hasSchema) %}
                    <div class="carousel-item schema-container {{ activeTab === 'schema' ? 'active' : '' }}"></div>
                {% endif %}
            </div>
        </div>
        <div class="js-code-output-executor {{ theme }}">
          {% if (openConsole && !outputAlways && !sqlOutputAlways) %}
            <div class="console-close {{ theme }}" :onclick={{ this.onConsoleCloseButtonEnter.bind(this) }}></div>
          {% endif %}

          <!-- If outputAlways or sqlOutputAlways is true and there is no output yet i.e. no code was run, show initial output text -->
          {% if (!waitingForOutput && (outputAlways || sqlOutputAlways) && !output && !sqlOutput && (!exception)) %}
            <div class="output-wrapper {{ theme }}">
              {% if (sqlOutputAlways) %}
                <div class="sql-output-panel {{ theme }}">
                  {% if (!executedAtLeastOnce) %}
                      <div class="panel-header">
                          <span class="panel-title">SQL</span>
                      </div>
                      <div class="sql-output-content">
                          {% unsafe sqlOutputInitial %}
                      </div>
                  {% else %}
                      <div class="panel-header">
                          <span class="panel-title">SQL</span>
                      </div>
                      <div class="sql-output-content">
                          {% unsafe sqlOutput %}
                      </div>
                  {% endif %}
                </div>
              {% endif %}

              {% if (outputAlways) %}
                <div class="standard-output-panel {{ theme }}">
                  {% if (!executedAtLeastOnce) %}
                      <div class="panel-header">
                          <span class="panel-title">OUTPUT</span>
                      </div>
                      <div class="code-output">
                          {% unsafe outputInitial %}
                      </div>
                  {% else %}
                      <div class="panel-header">
                          <span class="panel-title">OUTPUT</span>
                      </div>
                      <div class="code-output">
                          {% unsafe output %}
                      </div>
                  {% endif %}
                </div>
              {% endif %}
            </div>
          {% else %}
              {% if (waitingForOutput) %}
                  <div class="loader-wrapper {{ theme }}">
                    <div class="loader {{ theme }}">
                      <div class="loader-dot loader-dot-1"></div>
                      <div class="loader-dot loader-dot-2"></div>
                      <div class="loader-dot loader-dot-3"></div>
                      <div class="loader-dot loader-dot-4"></div>
                    </div>
                  </div>
              {% else %}
                  {% if (output && output != "") || exception || sqlOutput %}
                      <div class="output-wrapper {{ theme }}">
                          {% if (sqlOutput) %}
                              <div class="sql-output-panel {{ theme }}">
                                  <div class="panel-header">
                                      <span class="panel-title">SQL</span>
                                  </div>
                                  <div class="sql-output-content">
                                      {% unsafe sqlOutput %}
                                  </div>
                              </div>
                          {% endif %}

                          {% if (output && output != "") || exception %}
                            <div class="standard-output-panel {{ theme }}">
                                <div class="panel-header">
                                    <span class="panel-title">OUTPUT</span>
                                </div>

                                {% if (output && output != "") %}
                                <pre class="code-output">
                                    {% unsafe output %}
                                </pre>
                                {% endif %}
                                {% if exception %}
                                    <div class="code-output">
                                        <Exception
                                          {{...exception}}
                                          originalException={{ true }}
                                          onExceptionClick={{ this.onExceptionClick.bind(this) }}
                                        />
                                    </div>
                                {% endif %}
                            </div>
                          {% endif %}
                      </div>
                  {% endif %}
              {% endif %}
          {% endif %}
        </div>
    </div>

    {% if (shorterHeight) %}<button class="executable-fragment-wrapper__shorter" :onclick={{ this.onShorterClick.bind(this) }}>more</button>{% endif %}
</div>
